import { createApi } from "@reduxjs/toolkit/query/react";
import customBaseQuery from "../../../utils/customBaseQuery";
import { gql } from "graphql-request";

export const AllUserLearnings = createApi({
  reducerPath: "allUserLearningsApi",
  baseQuery: customBaseQuery,
  endpoints: (builder) => ({
    getAllUserLearnings: builder.query({
      query: ({ pageNo, searchKey, searchName }: any) => ({
        url: "/graphql",
        body: gql`
          query {
            fetchAllUsersLearnings(
              request: { 
              userName: "${searchName}", 
              artifactNames: ${searchKey ? `["${searchKey}"]` : "[]"}, 
              contentCount: 4 }
              criteria: {
                sortKey: "email"
                order: "ASC"
                pageNo: ${pageNo}
                pageCount: 10
              }
            ) {
              timestamp
              version
              error
              data {
                myReportees {
                  id
                  name {
                    fullName
                  }
                  email
                  profileImageUrl
                  employment {
                    bg
                    du
                    band
                    role
                    grade
                    title
                    clientName
                    designation
                    organization
                    operatingUnit
                    assignmentStatus
                  }
                  assignments {
                    artifactId
                    artifactType
                    title
                    shortDescription
                    longDescription
                    language
                    duration
                    difficultyLevel
                    branding {
                      banner
                      thumbnail
                      promo
                    }
                    sourceName
                    sourceType
                    prerequisite
                    learningObjective
                    demonstrableOutcome
                    brandingurls {
                      banner
                      thumbnail
                      promo
                    }
                    searchTags {
                      defaultTag
                    }
                    progressStatus
                    progressPercentage
                  }
                  assigned
                  selfLearning
                  completed
                  inProgress
                }
                pageNumber
                pageSize
                totalCount
              }
            }
          }
        `
      }),
      extraOptions: { service: "Catalog" },
      serializeQueryArgs: ({ endpointName }) => {
        return { endpointName };
      },
      merge(currentCacheData, responseData, otherArgs) {
        if (otherArgs?.arg?.pageNo > 0) {
          const messageMap = new Map();
          [
            ...currentCacheData?.fetchAllUsersLearnings?.data?.myReportees,
            ...responseData.fetchAllUsersLearnings?.data?.myReportees
          ].map((msg) => {
            if (!messageMap.has(msg.id)) {
              messageMap.set(msg.id, msg);
            }
          });
          const mergedResult = [...messageMap.values()];
          return {
            ...responseData,
            fetchAllUsersLearnings: {
              ...responseData.fetchAllUsersLearnings,
              data: {
                ...responseData.fetchAllUsersLearnings.data,
                myReportees: mergedResult
              }
            }
          };
        } else return responseData;
      }
    })
  })
});

export const { useGetAllUserLearningsQuery, useLazyGetAllUserLearningsQuery } =
  AllUserLearnings;
